export const Footer = ({ section }) => {
  const year = new Date().getFullYear();
  if (!section) return null;

  const socials = section.metadata?.socials || [];

  return (
    <footer data-testid="footer" className="relative bg-[#050505] border-t border-white/10 pt-20 pb-10 overflow-hidden">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10 mb-16">
          <h2 className="font-anton uppercase leading-[0.85] text-[#FAFAFA] text-6xl md:text-8xl lg:text-9xl">
            {section.title}<br />
            <span className="text-[#E85A24]">{section.title_accent}</span>
          </h2>
          <div className="flex flex-wrap gap-10 font-oswald uppercase tracking-[0.2em] text-sm">
            {socials.map((social) => (
              <a
                key={`${social.label}-${social.url}`}
                data-testid={`social-${String(social.label).toLowerCase()}`}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#A3A3A3] hover:text-[#E85A24] transition-colors duration-300"
              >
                {social.label}
              </a>
            ))}
            <a
              href="/terms-and-conditions"
              className="text-[#A3A3A3] hover:text-[#E85A24] transition-colors duration-300"
            >
              Terms & Conditions
            </a>
            <a
              href="/privacy-policy"
              className="text-[#A3A3A3] hover:text-[#E85A24] transition-colors duration-300"
            >
              Privacy Policy
            </a>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5 pt-8 border-t border-white/10">
          <p className="font-dm text-sm text-[#A3A3A3]">
            © {year} {section.body}
          </p>
          <p className="font-oswald uppercase tracking-[0.3em] text-xs text-[#A3A3A3]/60">
            {section.metadata?.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
};
